/*
 * @Author: 秦少卫 nihaojob@163.com
 * @Date: 2025-04-21 16:33:12
 * @LastEditors: 秦少卫 nihaojob@163.com
 * @LastEditTime: 2025-08-15 18:04:34
 * @FilePath: /kuaitu/src/router/index.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { createRouter, createWebHashHistory } from 'vue-router';
import routes from './routes';
import adminRoutes from './adminRoutes';
import podRoutes from './podRoutes';
// import acrylicRoutes from './acrylicRoutes';
import shopAdminRoutes from './shopAdmin';

const router = createRouter({
  routes: [...routes, ...adminRoutes, ...podRoutes, ...shopAdminRoutes],
  history: createWebHashHistory(),
  scrollBehavior() {
    return { top: 0 };
  },
});

const chunkReloadKey = 'chunk-load-reload-at';
const chunkLoadErrorPattern =
  /Failed to fetch dynamically imported module|Importing a module script failed|Loading chunk .* failed|ChunkLoadError/i;

// A user may keep an old page open while a new version is deployed. In that
// case, navigating to a lazy route can request a chunk from the previous build.
// Reload once so index.html picks up the new hashed asset URLs.
router.onError((error) => {
  if (!chunkLoadErrorPattern.test(error.message)) return;

  const now = Date.now();
  const lastReloadAt = Number(sessionStorage.getItem(chunkReloadKey) || 0);
  if (now - lastReloadAt < 10_000) return;

  sessionStorage.setItem(chunkReloadKey, String(now));
  window.location.reload();
});

router.afterEach((_to, _from, failure) => {
  if (!failure) sessionStorage.removeItem(chunkReloadKey);
});

export default router;
